export default class CouponUses {
  static async retrieve(axios, id) {
    const response = await axios.post(
      '/graphql/',
      `query{
        couponUsesRetrieve(id: ${id}) {
          id
          date
          currentUse
          couponsInstance {
            id
            coupons {
              id
              title
              images {
                url
              }
              description
              expirationDate
              price
              value
              saveValue
              discount
              notShowAgain
              distinguished
              hot
              new
            }
          }
          user {
            id
            username
            firstName
            lastName
            email
          }
          coupon {
            id
            title
            subTitle
            description
            smallDescription
            expirationDate
            images {
              id
              url
            }
            initialDate
            dailyUses
            totalUses
            maxPerson
            valuedAt
          }
          employment {
            id
            user {
              username
              email
              firstName
              lastName
            }
            branchOffice {
              id
              name
            }
          }
        }
      }`,
      {
        headers: {
          'Content-Type': 'application/graphql'
        }
      }
    );
    return response.data.data.couponUsesRetrieve;
  }

  static async all(axios) {
    const response = await axios.post(
      '/graphql/',
      `query {
        couponUsesList {
          results {
            id
            date
            currentUse
            couponsInstance {
              coupons {
                id
                title
                images {
                  url
                }
                description
                expirationDate
                price
                value
                saveValue
                discount
                notShowAgain
                distinguished
                hot
                new
              }
            }
            user {
              id
              username
              firstName
              lastName
              email
            }
            coupon {
              id
              title
              subTitle
              description
              smallDescription
              expirationDate
              images {
                id
                url
              }
              initialDate
              dailyUses
              totalUses
              maxPerson
              valuedAt
            }
            employment {
              id
              user {
                username
                email
                firstName
                lastName
              }
              branchOffice {
                id
                name
              }
            }
          }
        }
      } `,
      {
        headers: {
          'Content-Type': 'application/graphql'
        }
      }
    );

    return response.data.data.couponUsesList.results.reverse();
  }

  static async filter(axios, init, last) {
    const response = await axios.post(
      '/graphql/',
      `query {
        couponUsesList (date_Gte: "${init}", date_Lte: "${last}") {
          results {
            id
            date
            currentUse
            couponsInstance {
              coupons {
                id
                title
                images {
                  url
                }
                description
                expirationDate
                price
                value
                saveValue
                discount
                notShowAgain
                distinguished
                hot
                new
              }
            }
            user {
              id
              username
              firstName
              lastName
              email
            }
            coupon {
              id
              title
              subTitle
              description
              smallDescription
              expirationDate
              images {
                id
                url
              }
              initialDate
              dailyUses
              totalUses
              maxPerson
              valuedAt
            }
            employment {
              id
              user {
                username
                email
                firstName
                lastName
              }
              branchOffice {
                id
                name
              }
            }
          }
        }
      } `,
      {
        headers: {
          'Content-Type': 'application/graphql'
        }
      }
    );

    return response.data.data.couponUsesList.results.reverse();
  }

  static async allOfBranchOffice(axios, branchOffice, init, last) {
    let initField = init !== '' && init !== undefined ? `, date_Gte: "${init}"`: '';
    let lastField = last !== '' && last !== undefined ? `, date_Lte: "${last}"`: '';
    const response = await axios.post(
      '/graphql/',
      `query {
        couponUsesBranchOffice(branchOfficeId: ${branchOffice} ${initField} ${lastField}) {
          id
          date
          currentUse
          couponsInstance {
            id
            coupons {
              id
              title
              images {
                url
              }
              description
              expirationDate
              price
              value
              saveValue
              discount
              notShowAgain
              distinguished
              hot
              new
            }
          }
          user {
            id
            username
            firstName
            lastName
            email
          }
          coupon {
            id
            title
            subTitle
            description
            smallDescription
            expirationDate
            images {
              id
              url
            }
            initialDate
            dailyUses
            totalUses
            maxPerson
            valuedAt
          }
          employment {
            id
            user {
              username
              email
              firstName
              lastName
            }
            branchOffice {
              id
              name
            }
          }
        }
      }`,
      {
        headers: {
          'Content-Type': 'application/graphql'
        }
      }
    );

    return response.data.data.couponUsesBranchOffice;
  }

  static async allOfCompany(axios, company, init, last) {
    let initField = init !== '' && init !== undefined ? `, date_Gte: "${init}"`: '';
    let lastField = last !== '' && last !== undefined ? `, date_Lte: "${last}"`: '';

    const response = await axios.post(
      '/graphql/',
      `query {
        couponUsesCompany(companyId: ${company} ${initField} ${lastField}) {
          id
          date
          currentUse
          couponsInstance {
            id
            coupons {
              id
              title
              images {
                url
              }
              description
              expirationDate
              price
              value
              saveValue
              discount
              notShowAgain
              distinguished
              hot
              new
            }
          }
          user {
            id
            username
            firstName
            lastName
            email
          }
          coupon {
            id
            title
            subTitle
            description
            smallDescription
            expirationDate
            images {
              id
              url
            }
            initialDate
            dailyUses
            totalUses
            maxPerson
            valuedAt
          }
          employment {
            id
            user {
              username
              email
              firstName
              lastName
            }
            branchOffice {
              id
              name
            }
          }
        }
      }`,
      {
        headers: {
          'Content-Type': 'application/graphql'
        }
      }
    );

    return response.data.data.couponUsesCompany;
  }

  static async getUses(axios, couponsInstance, coupon, user) {
    const response = await axios.post(
      '/graphql/',
      `query{
        couponUsesList(couponsInstance: ${couponsInstance}, coupon: ${coupon}, user: ${user}) {
          results {
            id
          }
          totalCount
        }
      }`,
      {
        headers: {
          'Content-Type': 'application/graphql'
        }
      }
    );

    return response.data.data.couponUsesList.totalCount;
  }
}
